import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-friend-request-limit-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './friend-request-limit-popup.html',
  // Fixed-position overlay only — the host must not generate a box, or it
  // becomes an empty grid item (and a visible gap) inside the "All" page grid.
  styles: [':host { display: contents; }'],
})
export class FriendRequestLimitPopup {

  @Input() isOpen = false;
  @Input() hours: number | null = null;
  @Input() closeOnBackdrop = true;

  @Output() closed = new EventEmitter<void>();

  get hoursLabel(): string {
    if (!this.hours) return 'some time';
    return `${this.hours} ${this.hours === 1 ? 'hour' : 'hours'}`;
  }

  onClose(): void { this.closed.emit(); }
  onBackdropClick(): void { if (this.closeOnBackdrop) this.closed.emit(); }
}
